import Alpine from 'alpinejs';
import { Select } from './select';

Alpine.data('select', (config: SelectConfig) => new Select(config));
